import Toast from 'react-native-toast-message';

import {ERROR_MESSAGE} from '../../../ToastBottom';
import type {TillTokenizeError} from '../types';
import {getFormattedTokeniserErrors} from '../utils';

/**
 * Filter input to only allow numeric characters (0-9).
 * Used for expiry month/year fields to prevent non-numeric input.
 */
export const filterNumericOnly = (text: string): string => text.replace(/[^0-9]/g, '');

/**
 * Display toast notification for Till tokenizer errors.
 * Uses enhanced error formatting from utils/errorHandling.
 */
export const showToastIfTokeniserErrors = (errors: TillTokenizeError[]) => {
  const formattedErrors = getFormattedTokeniserErrors(errors);

  if (formattedErrors.length > 0) {
    Toast.show({
      type: ERROR_MESSAGE,
      text1: formattedErrors.length === 1 ? formattedErrors[0] : 'Please correct the following:',
      text2: formattedErrors.length > 1 ? formattedErrors.join('\n') : undefined,
    });
  }
};
